import { useAuth0 } from "@auth0/auth0-react";
import "assets/css/homepage.css";
import HomepageDifference from "components/homepage/HomepageDifference";
import HomepageHero from "components/homepage/HomepageHero";
import HomepageHowToPlay from "components/homepage/HomepageHowToPlay";
import HomepageIntroduce from "components/homepage/HomepageIntroduce";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const Homepage = () => {
  const { hash } = useLocation();
  const {loginWithRedirect} = useAuth0();
  const activateLogin = () => loginWithRedirect();


  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.replace("#", ""));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);

  return (
    <main className="homepage">
      <HomepageHero activateLogin={activateLogin} />
      <HomepageIntroduce />
      <HomepageHowToPlay activateLogin={activateLogin} />
      <HomepageDifference activateLogin={activateLogin} />
    </main>
  );
};

export default Homepage;
